/**
 * Shared `OverlayTrigger` props for a tooltip anchored to a cell in the
 * node-instance table. Both parts are load-bearing inside a scrolling table,
 * and both fail silently — the tooltip still renders, just clipped:
 *
 * - `container`: rendered inline, the popper is clipped by the table's
 *   `overflow: auto` box. Portalling to `body` takes it out of every clipping
 *   ancestor, the same reasoning `InfoTooltip` documents at length.
 * - `flip` + `fallbackPlacements`: react-bootstrap defaults `flip` to
 *   `placement.includes('auto')`, so an explicit placement like `top` DISABLES
 *   flipping and a row near the top edge gets a tooltip it cannot move. Opting
 *   in is what makes the fallbacks run.
 *
 * Callers keep their own `placement`; these props say where it may go instead.
 */
export const rowTooltipProps = {
  flip: true,
  container: () => document.body,
  popperConfig: { modifiers: [{ name: 'flip', options: { fallbackPlacements: ['bottom', 'right', 'left'] } }] },
};
